import { Anchor, Breadcrumbs, Text } from "@mantine/core"
import { FC, ReactNode } from "react"
import { useNavigate } from "react-router"

export type BreadcrumbItem = {
  label: string
  /** Navigation target. When absent the item renders as the current page (plain text). */
  path?: string
  icon?: ReactNode
}

type Props = {
  items: BreadcrumbItem[]
  showHomeIcon?: boolean
}

/** Canvas trail «Нүүр / Буцаалт / Жагсаалт»: plain 14px text, «/» separator, no icons. */
export const Breadcrumb: FC<Props> = ({ items }) => {
  const navigate = useNavigate()
  if (items.length === 0) return null

  return (
    <Breadcrumbs
      separator="/"
      separatorMargin={6}
      mb={4}
      styles={{ separator: { color: "var(--nw-text-2)", fontSize: "var(--nw-fz-body)" } }}
    >
      {items.map((item, index) =>
        item.path && index < items.length - 1 ? (
          <Anchor
            key={index}
            component="button"
            type="button"
            underline="hover"
            fz="var(--nw-fz-body)"
            c="var(--nw-text-2)"
            onClick={() => navigate(item.path!)}
          >
            {item.label}
          </Anchor>
        ) : (
          <Text key={index} span fz="var(--nw-fz-body)" c="var(--nw-text)">
            {item.label}
          </Text>
        ),
      )}
    </Breadcrumbs>
  )
}
